import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {NgxMaskModule} from "ngx-mask";
import { BeforeExpiredDialogComponent } from "./before-expired-dialog/before-expired-dialog.component";
import {RangeSliderComponent} from "./range-slider/range-slider.component";
import { SubmitSuccessAvDialogComponent } from "./submit-success-av-dialog/submit-success-av-dialog.component";
import { MaterialModule } from "../../material-module";
import { TranslateModule } from "@ngx-translate/core";
import { LottieModule } from "ngx-lottie";
import player from "lottie-web";
import { LoadingOverlayComponent } from "./loading-overlay/loading-overlay.component";
import { CarVariantDialogComponent } from './car-variant-dialog/car-variant-dialog.component';
import { ConfirmDriveplusDialogComponent } from './confirm-driveplus-dialog/confirm-driveplus-dialog.component';
import { ComReminderDialogComponent } from './com-reminder-dialog/com-reminder-dialog.component';
import { RoadtaxBlacklistedDialogComponent } from './roadtax-blacklisted-dialog/roadtax-blacklisted-dialog.component';
import { CookieConsentComponent } from "./cookie-consent/cookie-consent.component";

export function playerFactory() {
	return player;
}

@NgModule({
	declarations: [
		BeforeExpiredDialogComponent,
		SubmitSuccessAvDialogComponent,
		LoadingOverlayComponent,
  	CarVariantDialogComponent,
    RangeSliderComponent,
    ConfirmDriveplusDialogComponent,
    ComReminderDialogComponent,
    RoadtaxBlacklistedDialogComponent,
		CookieConsentComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		MaterialModule,
		TranslateModule,
    ReactiveFormsModule,
    NgxMaskModule,
		LottieModule.forRoot({ player: playerFactory }),
	],
	exports: [
		BeforeExpiredDialogComponent,
		LoadingOverlayComponent,
		RangeSliderComponent,
		CookieConsentComponent
	],
})
export class SharedComponentModule {}
